import { userLogic } from "../user";
import { subheaderLogic } from "../layout/subheader";

export default [...userLogic, ...subheaderLogic];
